
export const prototypeName = 'Servicebund.RodeoSteakDe:Component.StaticMap';